import { useNavigate } from "react-router-dom";

/**
 * Smooth-scrolls to a home page section by id, from any route.
 *
 * Sections are addressed by id rather than by passing refs down into the Navbar
 * and Footer: those refs only exist on the home page, so on /careers and
 * /policies they arrive as undefined and reading `.current` off them throws.
 * Looking the element up by id lets the same nav work everywhere — when the
 * section isn't on the current page we route home with a hash and let the home
 * page scroll once it mounts.
 */
export const useSectionNav = () => {
  const navigate = useNavigate();

  return (id) => {
    if (id === "top") {
      if (window.location.pathname === "/") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        navigate("/");
      }
      return;
    }

    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };
};
